import React from "react";
import styles from "./project.module.css";
import Navbar from "../../Components/Navbar/Navbar";
import { Col, Container, Row } from "react-bootstrap";
import {
  Heading,
  Paragraph,
} from "../../Components/TextComponents/TextComponents";
import VisionSection from "../../Components/Vision/VisionSection";
import ProjectSlider from "../../Components/ProjectSlider/ProjectSlider";
import Leaders from "../../Components/Leaders/Leaders";
import AllProjects from "../../Components/AllProjects/AllProjects";


const Project = () => {
  return (
    <React.Fragment>
      <div className={styles.main_section}>
        <Navbar />

        <Container>
          <Row>
            <Col md={6} sm={12}>
              <div className={styles.heroSection}>
                <Heading color="#fff">
                  Delivering Excellence Across Borders
                </Heading>
                <Paragraph color="#fff">
                  Explore our impactful projects that redefine industries and
                  empower communities.
                </Paragraph>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <VisionSection />
      <ProjectSlider />
      <AllProjects/>

      {/* ------------section-start--------- */}
      <div className={styles.trade_section}>
        <Container>
          <Row>
            <Col md={5} sm={12}>
              <div className={styles.section}>
                <h6>Project Highlight</h6>
                <p>
                  Our projects not only meet client expectations but also create
                  a lasting impact on industries and communities worldwide.
                </p>
              </div>
            </Col>
            <Col md={3} sm={12}>
              <div className={styles.section}>
                <h6>10 years</h6>
                <p>Over 10 years of delivering high-quality solutions.</p>
              </div>
            </Col>
            <Col md={3} sm={12}>
              <div className={styles.section}>
                <h6>5 Projects</h6>
                <p>Projects executed across five countries.</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      {/* ------------section-end--------- */}
      <Leaders />

    </React.Fragment>
  );
};

export default Project;
